import React, { useMemo, useEffect, useContext, useRef, useCallback } from 'react';
import { LocationContext } from '../LocationContext/LocationContext';

// Styles
import styles from './LocationMapPopup.module.scss';

// Icons
import IconX from '../../assets/images/featherIcons/IconX';

// Marker Details
import MarkerDetails from '../MarkerDetails/MarkerDetails';
import i18n from '../../i18n';

const LocationMapPopup = () => {
    const {
        openedLocationId,
        setOpenedLocationId,
        locationObjects,
    } = useContext(LocationContext);
    const popupContent = useRef(null);
    const closeBtnRef = useRef(null);
    const fadeLayer = useRef(null);
    const isMountedRef = useRef(true);
    const isMounted = useCallback(() => isMountedRef.current, []);

    const markerContent = useMemo(() => {
        return locationObjects.find(el => el.id === openedLocationId) || {};
    }, [openedLocationId, locationObjects]);

    useEffect(() => {
        openedLocationId && closeBtnRef.current?.focus();
    }, [openedLocationId, closeBtnRef]);

    useEffect(() => {
        isMountedRef.current = true;

        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const onScroll = () => {
        const scrollTop = popupContent.current.scrollTop;
        const offsetHeight = popupContent.current.offsetHeight;
        const height = popupContent.current.scrollHeight;

        if (fadeLayer?.current?.style) {
            if (scrollTop + offsetHeight >= height) {
                fadeLayer.current.style.opacity = '0';
                fadeLayer.current.style.transform = `translateY(${scrollTop}px)`;
            } else {
                fadeLayer.current.style.opacity = '1';
                fadeLayer.current.style.transform = `translateY(${
                    scrollTop + 10
                }px)`;
            }
        }
    };

    const detailsDOM = (markerContent) => {
        if (markerContent.categoryId === 'companyLocation') {
            return <MarkerDetails styles={styles} markerObject={markerContent} />;
        }
    };

    return (
        <div
            className={`${styles.popupWrapper} ${
                openedLocationId && styles.opened
            }`}
            key={openedLocationId}
            ref={popupContent}
            onScroll={() => onScroll()}
        >
            <div className={styles.nav}>
                <div className={`${styles.title} h4`}>{markerContent.name}</div>
                <div className={styles.buttonContainer}>
                    <button
                        type="button"
                        onClick={() => isMounted() && setOpenedLocationId('')}
                        className={styles.closeButton}
                        aria-label={i18n.t('closePopup')}
                        ref={closeBtnRef}
                    >
                        <IconX />
                    </button>
                </div>
            </div>
            {detailsDOM(markerContent)}
        </div>
    );
};

export default LocationMapPopup;
